// components/dashboard/user/Orders.jsx
import { Routes, Route, Link, useLocation } from "react-router-dom";
import HeaderOne from "../../../HeaderOne";
import Breadcrumb from "../../../Breadcrumb";
import ListOrders from "./ListOrders";
import ViewOrder from "./ViewOrder";
import TrackOrder from "./TrackOrder";
import ReturnReplace from "./ReturnReplace";
import Invoice from "./Invoice";
import './Orders.scss';

const Orders = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname.includes(path);

  return (
    <>
    <HeaderOne/>
    
    {/* Breadcrumb */}
    <Breadcrumb />
    
    <div className="orders-container">
      <h1 className="orders-header">My Orders</h1>

      <nav className="orders-nav">
        <Link to="" className={`orders-tab ${isActive("orders") && !isActive("view") ? "active" : ""}`}>
          List Orders
        </Link>
      </nav>

      <div className="orders-content">
        <Routes>
          {/* Parent list of orders */}
          <Route path="/" element={<ListOrders />} />

          {/* Nested dynamic routes for a specific order */}
          <Route path=":orderId/*" element={<ViewOrder />}>
            <Route path="track" element={<TrackOrder />} />
            <Route path="replace" element={<ReturnReplace />} />
            <Route path="invoice" element={<Invoice />} />
          </Route>
        </Routes>
      </div>
    </div>
    </>
  );
};

export default Orders;
